import { render, staticRenderFns } from "./IconYpoLogo.vue?vue&type=template&id=78ed3196&"
import script from "./IconYpoLogo.vue?vue&type=script&lang=js&"
export * from "./IconYpoLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports